import { Card, CardContent } from '@design-system';
import { QUOTE_AGE_RANGE } from '@shared';
import { Figure } from './figures';

/** What the quote search covers, shown while it runs. */
export function QuoteSearchStats({ carrierCount }: { carrierCount: number }) {
  return (
    <Card className="bg-primary/5 border-primary/10">
      <CardContent className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <Figure label="Quote combinations" value="1M+" />
        <Figure label="Insurance carriers" value={carrierCount || '—'} />
        <Figure label="Types of coverage" value="3" />
        <Figure label="Ages quoted" value={`${QUOTE_AGE_RANGE.min}–${QUOTE_AGE_RANGE.max}`} />
      </CardContent>
    </Card>
  );
}
